module.exports = __webpack_public_path__ + "files/9525acec3865f607bcd1460a6f3baacd.png";